import { create } from 'zustand';

export const useBcmRpoStore = create((set) => ({
    items: [],
    loading: false,
    pagination: { current: 1, pageSize: 10, total: 0 },
    error: null,

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setPagination: (pagination) => set({ pagination }),
    clearError: () => set({ error: null }),
}));
